// project import
import accommodation from "./accommodation";
import dashboard from "./dashboard";
import guests from "./guests";
import reservations from "./reservations";
import admin from "./admin";

const menuItems = {
  items: [dashboard, reservations, guests, accommodation, admin],
};

export default menuItems;
